<template><section><h1>Btn</h1>
<blockquote>
<p>按钮组件</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>size</td>
<td style="text-align:left">按钮尺寸，可选值 <code>sm</code>/<code>md</code>/<code>lg</code></td>
<td><code>String</code></td>
<td><code>md</code></td>
</tr>
<tr>
<td>disabled</td>
<td style="text-align:left">是否禁用</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>is_loading</td>
<td style="text-align:left">是否加载中</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>loading_text</td>
<td style="text-align:left">加载时的文本</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>prefix</td>
<td style="text-align:left">前置图标</td>
<td><code>String</code></td>
<td>-</td>
</tr>
<tr>
<td>suffix</td>
<td style="text-align:left">后置图标</td>
<td><code>String</code></td>
<td>-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Btn.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-1.vue?143dfd47